export default "__VITE_ASSET__DajjQIHJ__"